import { MAX_RECORDING_FILE_SIZE } from 'utils/constants/constants';

export const logHigherFileSize = (fileValue, context) => {
  if (
    fileValue instanceof File &&
    fileValue.isRecordedVideo &&
    fileValue.size > MAX_RECORDING_FILE_SIZE
  ) {
    let sizeInMB = (fileValue.size / (1024 * 1024)).toFixed(2);
    const errorMessage = `There is an error with your file. File size exceeds 11MB, current value is ${sizeInMB} MB`;
    console.error(`Video Recording Error on ${context}: `, errorMessage);
  }
};
